const PUSH_SERVER_URL = process.env.REACT_APP_PUSH_SERVER_URL || "";

export async function getVapidPublicKey() {
  if (!PUSH_SERVER_URL) return null;
  try {
    const res = await fetch(`${PUSH_SERVER_URL}/notifications/vapid-public-key`);
    const data = await res.json();
    return data.publicKey;
  } catch {
    return null;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return null;
  // Only register under /app/ paths
  if (!window.location.pathname.startsWith("/app")) return null;
  try {
    const reg = await navigator.serviceWorker.register("/sw-app.js", { scope: "/app/" });
    await navigator.serviceWorker.ready;
    return reg;
  } catch {
    return null;
  }
}

export async function subscribeToPush() {
  const vapidKey = await getVapidPublicKey();
  if (!vapidKey) return null;

  const reg = await registerServiceWorker();
  if (!reg) return null;

  try {
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
    }
    return sub.toJSON();
  } catch {
    return null;
  }
}

export async function unsubscribeFromPush() {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/app/");
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (sub) await sub.unsubscribe();
  } catch {
    // ignore
  }
}

export async function getPushSubscription() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return null;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/app/");
    if (!reg) return null;
    const sub = await reg.pushManager.getSubscription();
    return sub ? sub.toJSON() : null;
  } catch {
    return null;
  }
}

export function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}
